import { deviceId } from '@/common/const';

const REMIND_KEY = 'remind_me_later_config';
const ONE_DAY_KEY = 'one_day_key';

// 7 天不弹窗的设置
export const setRemindMeLaterConfig = () => {
    window?.localStorage?.setItem(`${REMIND_KEY}_${deviceId}`, `${Date.now()}`);
};
export const checkIfPopupByTime = () => {
    const lastTime = window?.localStorage?.getItem(`${REMIND_KEY}_${deviceId}`);
    if (!lastTime) {
        return true;
    }

    const now = Date.now();
    const diff = now - Number(lastTime);
    // 大于 7 天才允许弹窗
    if (diff >= 1000 * 60 * 60 * 24 * 7) {
        return true;
    }
    return false;
};

// 一天至多弹一次的设置
export const checkIfPopupInOneDay = () => {
    const lastTime = window?.localStorage?.getItem(`${ONE_DAY_KEY}_${deviceId}`);
    if (!lastTime) {
        window?.localStorage?.setItem(`${ONE_DAY_KEY}_${deviceId}`, `${Date.now()}`);
        return true;
    }

    const now = Date.now();
    const diff = now - Number(lastTime);
    // 大于 1 天才允许弹窗
    if (diff >= 1000 * 60 * 60 * 24) {
        window?.localStorage?.setItem(`${ONE_DAY_KEY}_${deviceId}`, `${now}}`);
        return true;
    }

    return false;
};
